import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_public/login')({
  component: lazyRouteComponent(() => import('&/features/auth/pages/login-page')),
});
